import { create } from "zustand";
import type { MeResponse } from "@opus-dt/shared-types";

// A store guarda só a PRESENÇA de sessão (user) + o flag de boot. O access token vive apenas no
// módulo do api-client (fonte única): a store não precisa dele e ninguém mais o lê (o WebSocket e o
// Bearer leem `api.getAccessToken()`; o realtime é dirigido por `user`).
interface AuthState {
  user: MeResponse | null;
  initialized: boolean;
  setSession: (params: { user: MeResponse }) => void;
  clearSession: () => void;
  setInitialized: (v: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  initialized: false,
  setSession: ({ user }) => set({ user }),
  clearSession: () => set({ user: null }),
  setInitialized: (v) => set({ initialized: v }),
}));
